import { getUserPreferredSubTopicTitle } from "@utils/routing";
import { useSubTopicMeta } from "../../../../../components/CoreDataProvider";
import classes from "./SubTopicTitle.module.css";

export const useSubTopicTitleStyles = ({
  subjectColorIndex,
}: {
  subjectColorIndex: string;
}) => ({
  classes,
  style: {
    "--stt-c8": `var(--mantine-color-${subjectColorIndex}-8)`,
  } as React.CSSProperties,
});

export default function SubTopicTitle({
  subjectColorIndex,
  subTopicDocumentId,
}: {
  subjectColorIndex: string;
  subTopicDocumentId: string;
}) {
  const subTopicMeta = useSubTopicMeta(subTopicDocumentId);
  if (!subTopicMeta) {
    return null;
  }
  return (
    <>
      <b>{getUserPreferredSubTopicTitle(subTopicMeta).split(":")[0]}</b>
      <span
        className={classes.subTopicTitle}
        style={
          {
            "--stt-c8": `var(--mantine-color-${subjectColorIndex}-8)`,
          } as React.CSSProperties
        }
        dangerouslySetInnerHTML={{
          __html: `: ${subTopicMeta.title.replace(" (HL)", "")}${
            subTopicMeta.isHL ? `&nbsp;<span>(HL)</span>` : ""
          }`,
        }}
      />
    </>
  );
}
